import React from "react";
//outsource
import { Row, Col, Typography } from "antd";

//components
import TimeControl from "./time_control";
import TimeTable from "./time_table";

const { Title } = Typography;

const TimeSheetTable = ({ setUserId, userId }) => {
  // -------------------------- VAR --------------------------
  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------

  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------
  const renderBody = () => {
    return (
      <Row>
        <Col xl={24} lg={24} md={24} xs={24}>
          <TimeControl setUserId={setUserId} userId={userId} />
        </Col>
        <Col xl={24} lg={24} md={24} xs={24}>
          <TimeTable />
        </Col>
      </Row>
    );
  };
  // -------------------------- MAIN --------------------------
  return (
    <Row>
      <Col span={24}>{renderBody()} </Col>
    </Row>
  );
};

export default TimeSheetTable;
